/* global s */
'use strict';

class HelpCenterFaq {
	constructor(_options) {
		this.click_number = 0;
		this.last_search_string = '';
		this.log_data_from = _options.logDataFrom || 'faq';

		this.pageEvents();
	}

	pageEvents() {
		const _this = this;

		// Bind click events for dynamic content
		document.addEventListener('click', (event) => {
			const questionSelector = event.target.closest('.faq-track-click');

			if (questionSelector) {
				const questionId = questionSelector.getAttribute('data-id');
				const questionHasCollapse = questionSelector.getAttribute('data-toggle') === 'collapse';
				const questionExpanded = questionSelector.getAttribute('aria-expanded') === 'false';

				if (questionId) {
					// Skip track log click if question is collapsable and expanded
					if (questionHasCollapse && questionExpanded) {
						return false;
					}
					_this.handleLogClick(questionId);
				}
			}
		});
	}

	/**
	 * Log a click on a question. Helps in providing the top answers for a specific question
	 *
	 * @param {string}  question_id
	 *
	 */
	handleLogClick(question_id) {
		this.click_number++;

		try {
			const form_data = new FormData();
			form_data.append('action', 'log');
			form_data.append('from', this.log_data_from);
			form_data.append('message', this.last_search_string);
			form_data.append('question_id', question_id);
			form_data.append('click_number', this.click_number);
			const fetch = s.common.fetcher(
				s.url('help_center_process'),
				{
					method: 'post',
					body: form_data
				}
			);
			console.log('HelpCenterFaq::handleLogClick question(%o) success', question_id);
			return fetch.ready;
		} catch (e) {
			console.error('HelpCenterFaq::handleLogClick question(%o) failed', question_id);
		}
	}
}
